// components/AuthorshipAndLicense.js
export default function AuthorshipAndLicense() {
  return (
    <div className="text-left text-sm mt-4">
      {/* Reviewer / Author Information */}
      <p className="font-light mb-3">
        Reviewed by <b>Matan Bodek</b>, Licensed General Contractor
        <br />
        CSLB License <span className="text-primary font-medium">#1159287</span>
      </p>

      {/* License Verification Link */}
      <p className="font-light mb-3">
        License verified via the
        <br/>
        <a
          href="https://www.cslb.ca.gov/OnlineServices/CheckLicenseII/CheckLicense.aspx"
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-primary"
        >
          California Contractors State License Board (CSLB)
        </a>
      </p>
    </div>
  );
}